import { RadioButtonOption } from "apps/portal/src/components/atoms";

import { PricingStructure, TypeOfCost } from "../../types";

export const PRICING_STRUCTURE_OPTIONS: RadioButtonOption<PricingStructure>[] =
  [
    { label: "Free", value: "FREE" },
    { label: "Fixed Price", value: "FIXED_PRICE" },
  ];

export const TYPE_OF_COST_OPTIONS: RadioButtonOption<TypeOfCost>[] = [
  { label: "Price", value: "PRICE" },
  { label: "Credits", value: "CREDITS" },
  { label: "Both", value: "BOTH" },
];
